import { getHost } from './getHost';

export const getTopLevelDomain = (host?: string) => /(\w+\.\w+)$/.exec(getHost(host))?.[0];
